import { render, staticRenderFns } from "./NewPasswordModal.vue?vue&type=template&id=a749dd22&scoped=true"
import script from "./NewPasswordModal.vue?vue&type=script&lang=js"
export * from "./NewPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./NewPasswordModal.vue?vue&type=style&index=0&id=a749dd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a749dd22",
  null
  
)

export default component.exports